import {
  _ULong___init__impl__c78o9k2ace6d5rqjy3k as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb3nuonax14svlz as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
} from './ULong.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { contains2ejsq2kq1axf2 as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from './js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ULongArray___init__impl__twm1l3(storage) {
  return storage;
}
function _ULongArray___get_storage__impl__28e64j($this) {
  return $this;
}
function _ULongArray___init__impl__twm1l3_0(size) {
  return _ULongArray___init__impl__twm1l3(new BigInt64Array(size));
}
function ULongArray__get_impl_pr71q9($this, index) {
  // Inline function 'kotlin.toULong' call
  var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
  return _ULong___init__impl__c78o9k(this_0);
}
function ULongArray__set_impl_z19mvh($this, index, value) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  tmp[index] = _ULong___get_data__impl__fggpzb(value);
}
function _ULongArray___get_size__impl__ju6dtr($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length;
}
function ULongArray__iterator_impl_cq4d2h($this) {
  return new (Iterator())(_ULongArray___get_storage__impl__28e64j($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.zu_1 = array;
        this.av_1 = 0;
      }
      v1() {
        return this.av_1 < this.zu_1.length;
      }
      bv() {
        var tmp;
        if (this.av_1 < this.zu_1.length) {
          var _unary__edvuaz = this.av_1;
          this.av_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toULong' call
          var this_0 = this.zu_1[_unary__edvuaz];
          tmp = _ULong___init__impl__c78o9k(this_0);
        } else {
          throw NoSuchElementException().f2(this.av_1.toString());
        }
        return tmp;
      }
      w1() {
        return new (ULong())(this.bv());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function ULongArray__contains_impl_v9bgai($this, element) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
  return contains(tmp, tmp$ret$0);
}
function ULongArray__contains_impl_v9bgai_0($this, element) {
  if (!(element instanceof ULong()))
    return false;
  return ULongArray__contains_impl_v9bgai($this.cv_1, element instanceof ULong() ? element.xu_1 : THROW_CCE());
}
function ULongArray__containsAll_impl_xx8ztf($this, elements) {
  var tmp0 = isInterface(elements, Collection()) ? elements : THROW_CCE();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.s1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.u1();
    while (_iterator__ex2g4s.v1()) {
      var element = _iterator__ex2g4s.w1();
      var tmp_0;
      if (element instanceof ULong()) {
        var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = element.xu_1;
        var tmp$ret$1 = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = contains(tmp_1, tmp$ret$1);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
  return ULongArray__containsAll_impl_xx8ztf($this.cv_1, elements);
}
function ULongArray__isEmpty_impl_c3yngu($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length === 0;
}
function ULongArray__toString_impl_wqk1p5($this) {
  return 'ULongArray(storage=' + toString($this) + ')';
}
function ULongArray__hashCode_impl_aze4wa($this) {
  return hashCode($this);
}
function ULongArray__equals_impl_vwitwa($this, other) {
  if (!(other instanceof ULongArray()))
    return false;
  var tmp0_other_with_cast = other.cv_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ULongArrayClass;
function ULongArray() {
  if (ULongArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.cv_1 = storage;
      }
      v2() {
        return _ULongArray___get_size__impl__ju6dtr(this.cv_1);
      }
      u1() {
        return ULongArray__iterator_impl_cq4d2h(this.cv_1);
      }
      dv(element) {
        return ULongArray__contains_impl_v9bgai(this.cv_1, element);
      }
      y2(element) {
        return ULongArray__contains_impl_v9bgai_0(this, element);
      }
      ev(elements) {
        return ULongArray__containsAll_impl_xx8ztf(this.cv_1, elements);
      }
      v4(elements) {
        return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
      }
      s1() {
        return ULongArray__isEmpty_impl_c3yngu(this.cv_1);
      }
      toString() {
        return ULongArray__toString_impl_wqk1p5(this.cv_1);
      }
      hashCode() {
        return ULongArray__hashCode_impl_aze4wa(this.cv_1);
      }
      equals(other) {
        return ULongArray__equals_impl_vwitwa(this.cv_1, other);
      }
    }
    initMetadataForClass($, 'ULongArray', VOID, VOID, [Collection()]);
    ULongArrayClass = $;
  }
  return ULongArrayClass;
}
//region block: exports
export {
  _ULongArray___init__impl__twm1l3_0 as _ULongArray___init__impl__twm1l33skamtyptd0bw,
  _ULongArray___init__impl__twm1l3 as _ULongArray___init__impl__twm1l3177xx31ho2ogr,
  ULongArray__get_impl_pr71q9 as ULongArray__get_impl_pr71q91hrljiwf3ydw7,
  ULongArray__set_impl_z19mvh as ULongArray__set_impl_z19mvh363pb115v7opl,
  _ULongArray___get_size__impl__ju6dtr as _ULongArray___get_size__impl__ju6dtr2nah336epvy32,
  _ULongArray___get_storage__impl__28e64j as _ULongArray___get_storage__impl__28e64j18lfm63gboypn,
  ULongArray as ULongArray3nd0d80mdwjj8,
};
//endregion

//# sourceMappingURL=ULongArray.mjs.map
